import React, { useState } from 'react'
import Modal from 'react-responsive-modal'
import { useDispatch } from 'react-redux'
import styles from './styles.module.css'
import { useFormik } from 'formik'
import { Input } from '../../components/ModalInputs'
import * as Yup from 'yup'
import ModalFooter from '../../components/ModalFooter/ModalFooter'
import { createTypeOfDocument, updateTypeOfDocument } from '../../actions/typesOfDocuments'

const validationSchema = Yup.object({
  name: Yup.string().required('обязательное поле').max(30, 'Должно быть не более 30 символов'),

})

export default function ModalComponent({ data, closeModal, height, addMode, handleChangeRow, arrValuesName }) {

  // const dispatch = useDispatch()

  // const handleCreate = (values) => {
  //   dispatch(createTypeOfDocument(values))
  //   closeModal()
  // }

  // const handleUpdate = (values) => {
  //   dispatch(updateTypeOfDocument(values))
  //   closeModal()
  // }

  const {
    values,
    errors,
    touched,
    submitCount,
    handleChange,
    handleSubmit
  } = useFormik({
    initialValues: addMode ? {} : data,
    enableReinitialize: true,
    // validateOnChange: true,
    // validationSchema: validationSchema,
    onSubmit: handleChangeRow
  })

  // const error = (fieldName) => (touched[fieldName] || submitCount) && errors[fieldName]

  return (
    <Modal
      open={!!data}
      onClose={() => false}
      showCloseIcon={false}
      height={height}
      center
      classNames={{
        // overlay: styles.overlay,
        modal: styles.custom
      }}
    >
      <>
        <div className={styles.modalLocal}  >
          <div className={styles.tabWrapper} >
            {arrValuesName.map(cell =>
              <div className={styles.inputsRow}>
                <Input
                  label={cell[1]}
                  name={cell[0]}
                  value={values[cell[0]]}
                  // error={error('name')}
                  onChange={handleChange}
                  style={{ width: '600px' }}
                />
              </div>

            )}


          </div>
        </div>

        <ModalFooter handleSubmit={handleSubmit} closeModal={closeModal} />
      </>
    </Modal>

  )
}
